<template>
  <div class="about">
    <div class="container">
      <h2 class="section-title">{{ $t('about.title') }}</h2>
      
      <div class="about-content">
        <div class="profile-image">
          <img src="/images/profile.png" alt="Leo-Martin" />
        </div>
        
        <div class="about-text">
          <h2>{{ $t('about.greeting') }}</h2>
          <p class="intro">
            {{ $t('about.intro') }}
          </p>
          
          <div class="about-section">
            <h3>{{ $t('about.journey.title') }}</h3>
            <p>{{ $t('about.journey.part1') }}</p>
            <p>{{ $t('about.journey.part2') }}</p>
          </div>
          
          <div class="about-section">
            <h3>{{ $t('about.approach.title') }}</h3>
            <p>{{ $t('about.approach.part1') }}</p>
            <p>{{ $t('about.approach.part2') }}</p>
          </div>
          
          <div class="about-section">
            <h3>{{ $t('about.hobbies.title') }}</h3>
            <p>{{ $t('about.hobbies.description') }}</p>
          </div>
        </div>
      </div>
      
      <div class="skills-section">
        <h2 class="section-subtitle">{{ $t('about.skills') }} & {{ $t('about.experience') }}</h2>
        
        <div class="skills-grid">
          <div class="skill-category">
            <h3>{{ $t('about.skillCategories.development.title') }}</h3>
            <div class="skills-list">
              <SkillRating :name="$t('about.skillCategories.development.skill1')" :rating="5" />
              <SkillRating :name="$t('about.skillCategories.development.skill2')" :rating="4.5" />
              <SkillRating :name="$t('about.skillCategories.development.skill3')" :rating="4.5" />
              <SkillRating :name="$t('about.skillCategories.development.skill4')" :rating="4.5" />
              <SkillRating :name="$t('about.skillCategories.development.skill5')" :rating="4" />
              <SkillRating :name="$t('about.skillCategories.development.skill6')" :rating="4" />
              <SkillRating :name="$t('about.skillCategories.development.skill7')" :rating="3" />
              <SkillRating :name="$t('about.skillCategories.development.skill8')" :rating="3" />
            </div>
          </div>
          
          <div class="skill-category">
            <h3>{{ $t('about.skillCategories.cloud.title') }}</h3>
            <div class="skills-list">
              <SkillRating :name="$t('about.skillCategories.cloud.skill1')" :rating="5" />
              <SkillRating :name="$t('about.skillCategories.cloud.skill2')" :rating="5" />
              <SkillRating :name="$t('about.skillCategories.cloud.skill3')" :rating="4" />
              <SkillRating :name="$t('about.skillCategories.cloud.skill4')" :rating="3.5" />
              <SkillRating :name="$t('about.skillCategories.cloud.skill5')" :rating="3.5" />
              <SkillRating :name="$t('about.skillCategories.cloud.skill6')" :rating="3.5" />
            </div>
          </div>
          
          <div class="skill-category">
            <h3>{{ $t('about.skillCategories.dataScience.title') }}</h3>
            <div class="skills-list">
              <SkillRating :name="$t('about.skillCategories.dataScience.skill1')" :rating="5" />
              <SkillRating :name="$t('about.skillCategories.dataScience.skill2')" :rating="4.5" />
              <SkillRating :name="$t('about.skillCategories.dataScience.skill3')" :rating="3.5" />
              <SkillRating :name="$t('about.skillCategories.dataScience.skill4')" :rating="3.5" />
              <SkillRating :name="$t('about.skillCategories.dataScience.skill5')" :rating="3.5" />
              <SkillRating :name="$t('about.skillCategories.dataScience.skill6')" :rating="1.5" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkillRating from '@/components/SkillRating.vue'

export default {
  name: 'AboutView',
  components: {
    SkillRating
  }
}
</script>

<style lang="scss" scoped>
.about {
  padding: 1rem 0;
  position: relative;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  z-index: 1; /* Ensure content is above weather effects */
}

.section-title {
  margin-bottom: 2rem;
  text-align: center;
  font-size: 2.5rem;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    width: 80px;
    height: 4px;
    background-color: var(--color-primary);
    margin: 1rem auto 0;
  }
}

.about-content {
  display: grid;
  grid-template-columns: 1.2fr 1.8fr; /* Changed from 1fr 2fr to give more space to the image */
  gap: 2rem; /* Reduced gap to give more space to content */
  margin-bottom: 4rem;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  background-color: var(--color-card-bg); /* Using card background with higher opacity */
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.profile-image {
  position: relative;
  z-index: 2; /* Ensure image is above weather effects */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
    max-height: 100%;
  }
}

.about-text {
  h2 {
    margin-bottom: 1rem;
    font-size: 2rem;
  }
  
  .intro {
    font-size: 1.25rem;
    margin-bottom: 2rem;
    color: var(--color-secondary);
  }
}

.about-section {
  margin-bottom: 2rem;
  
  h3 {
    margin-bottom: 1rem;
    position: relative;
    
    &::after {
      content: '';
      display: block;
      width: 40px;
      height: 3px;
      background-color: var(--color-primary);
      margin-top: 0.5rem;
    }
  }
  
  p {
    margin-bottom: 1rem;
    line-height: 1.7;
  }
}

.skills-section {
  margin-bottom: 4rem;
  position: relative;
  z-index: 1; /* Ensure skills are above weather effects */
}

.section-subtitle {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    width: 50px;
    height: 3px;
    background-color: var(--color-primary);
    margin: 1rem auto 0;
  }
}

.skills-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.skill-category {
  background-color: var(--color-card-bg);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px var(--color-shadow);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px var(--color-shadow);
  }
  
  h3 {
    margin-bottom: 1rem;
    text-align: center;
    color: var(--color-primary);
    font-size: 1.3rem;
    position: relative;
    
    &::after {
      content: '';
      display: block;
      width: 40px;
      height: 3px;
      background-color: var(--color-primary);
      margin: 0.5rem auto 0;
    }
  }
}

.skills-list {
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>